<script lang="ts">
  import { getAppConfig } from '../../../common/config/app-config';

  export let data: any;

  const { encodedContextPath } = getAppConfig();
</script>

<a href={encodedContextPath + (data?.algoliaUrl ? data.algoliaUrl : data.url)}>
  <div class="category-container" style={data.backgroundColor ? 'background:' + data.backgroundColor : '#F3F9FC'}>
    <div class="product-category-container">
      <img src={data.iconUrl} alt="image" />
      <h3>{data.linkName}</h3>
    </div>
  </div>
</a>

<style lang="scss">
  @import '../../common/styles/colors.new.scss';

  .product-category-container {
    cursor: pointer;
    display: flex;
    width: 159px;
    padding: 12px 24px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    aspect-ratio: 1;
    height: 130px;
    @include desktop-min-width {
      width: 312px;
      height: 312px;
      padding: 32px 48px;
    }
    img {
      height: 70px;
      aspect-ratio: auto;
      object-fit: contain;
      @include desktop-min-width {
        height: 168px;
      }
    }
    h3 {
      margin: 10px 0 0;
      font-size: 15px;
      font-weight: 500;
      line-height: 20px;
      color: $neutral-dark-01;
      text-align: center;
      @include desktop-min-width {
        font-size: 24px;
        line-height: 26px;
        margin: 20px 0 0;
      }
    }
  }
</style>
